import { render } from "./Switch.vue?vue&type=template&id=47de862a"
import script from "./Switch.vue?vue&type=script&lang=js"
export * from "./Switch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/pro/Forms/Switch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "47de862a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47de862a', __exports__)) {
    api.reload('47de862a', __exports__)
  }
  
  module.hot.accept("./Switch.vue?vue&type=template&id=47de862a", () => {
    api.rerender('47de862a', render)
  })

}


export default __exports__